import merge from 'lodash-es/merge';
import { commonEnv } from './environment.common';

const env: Partial<typeof commonEnv> = {
  production: false,
  isLocal: false,
  auth0Config: {
    domain: 'auth.ppe.cloudmed.com',
    clientId: '7VoHbitnpy66FEZ8QZav3J6sLMhk60lY',
    audience: 'ppe.cloudmed',
    redirectUri: window.location.origin + '/callback',
    useRefreshTokens: true,
    httpInterceptor: {
      allowedList: ['https://usermanagementapi.ppe.cloudmed.com/*', 'https://ps-payer-rules-api.ppe.cloudmed.com/*'],
    },
  },
  api: {
    payerRulesApiBaseURL: 'https://ps-payer-rules-api.ppe.cloudmed.com/api/',
    riUserManagementBaseURL: 'https://usermanagementapi.ppe.cloudmed.com/',
  },
  uiUrl: {
    accountInfoURL: 'https://app.ppe.cloudmed.com/account-info?id=',
    adminUrl: 'https://admin.ppe.cloudmed.com/',
  },
};
export const environment = merge(commonEnv, env);
